/**
 * Dermatologie — specialty manifest.
 *
 * Maintained through the Specialty Registry. The manifest is data: the shell
 * reads it and knows nothing about this specialty.
 *
 * Legacy codes resolved here: DERM
 * Catalogue acts (NGAP Maroc): 264
 */
import { defineSpecialty } from "../types";

export const dermatologie = defineSpecialty(
{
  "id": "dermatologie",
  "label": "Dermatologie",
  "short": "Dermato.",
  "scope": "Peau et phanères",
  "aliases": [
    "DERM"
  ],
  "doctorSpecs": [
    "Dermatologie"
  ],
  "featureFlag": "ux.v2.dermatologie",
  "theme": {
    "primary": "oklch(0.72 0.16 330)",
    "primaryForeground": "oklch(0.98 0.005 240)",
    "accent": "oklch(0.78 0.16 80)",
    "accentForeground": "oklch(0.18 0.02 240)",
    "destructive": "oklch(0.65 0.22 27)",
    "success": "oklch(0.78 0.18 150)",
    "warning": "oklch(0.78 0.16 80)",
    "surface": "oklch(0.205 0.006 240)",
    "radius": "0.75rem",
    "fontDisplay": "\"Inter\", ui-sans-serif, system-ui, sans-serif"
  },
  "navigation": [
    {
      "id": "consult",
      "label": "Consultation",
      "icon": "Stethoscope",
      "route": "/clinical/consult",
      "order": 1,
      "requires": []
    },
    {
      "id": "lesions",
      "label": "Lésions",
      "icon": "Scan",
      "route": "/clinical/lesions",
      "order": 2,
      "requires": []
    },
    {
      "id": "imaging",
      "label": "Imagerie",
      "icon": "Image",
      "route": "/clinical/imaging",
      "order": 3,
      "requires": [
        "imaging"
      ]
    },
    {
      "id": "procedures",
      "label": "Actes",
      "icon": "Sparkles",
      "route": "/clinical/procedures",
      "order": 4,
      "requires": []
    },
    {
      "id": "prescription",
      "label": "Ordonnance",
      "icon": "Pill",
      "route": "/clinical/prescription",
      "order": 5,
      "requires": []
    }
  ],
  "panels": [
    {
      "id": "lesions",
      "label": "Lésions",
      "icon": "Scan",
      "component": "LesionGrid",
      "order": 1,
      "requires": []
    },
    {
      "id": "photos",
      "label": "Photos",
      "icon": "Camera",
      "component": "ClinicalImageGallery",
      "order": 2,
      "requires": []
    },
    {
      "id": "timeline",
      "label": "Chronologie",
      "icon": "History",
      "component": "PatientTimeline",
      "order": 3,
      "requires": []
    }
  ],
  "ngap": {
    "specialtyScope": "Dermatologie",
    "subSpecialties": [
      "Consultation",
      "Photothérapie",
      "Laser",
      "Chirurgie cutanée"
    ],
    "catalogueActs": 264
  },
  "terminology": {
    "icd10": [
      "L00",
      "L20",
      "L40",
      "L60",
      "L80"
    ],
    "loinc": [
      "11156-7",
      "72166-2"
    ],
    "snomed": []
  },
  "deviceProfiles": [
    "derma-camera",
    "laser-portable"
  ],
  "locales": [
    "fr",
    "ar"
  ]
}
);

export default dermatologie;
